export default __webpack_public_path__ + "static/media/17.68b7c767.png";